import React, { useMemo } from "react";
import PropTypes from "prop-types";

import ConfirmDialog from "dialogs/ConfirmDialog";

import usePatchTagsData from "hooks/usePatchTagsData";

import {
  DELETE_ACCOUNT_IQ_PATCH_TAG_FILE,
  GET_ACCOUNT_FILES_NAME,
  UPDATE_ACCOUNT_IQ_PATCH_TAG_FILE,
} from "graphqlQueries/accountFiles";

import {
  READ_VERSION_FILES_QUERY_NAME,
  UPDATE_IQ_PATCH_TAG_FILE,
  DELETE_IQ_PATCH_TAG_FILE,
} from "graphqlQueries/versions";

import DeleteIcon from "assets/svg/delete.svg";

import { ACCOUNT, VERSION } from "constants/patchTagSections";

import pluralize from "utils/pluralizer";

const DeletePatchTagsDialog = (props) => {
  const {
    selected,
    name,
    onSuccessCallback,
    onClose,
    accountId,
    version,
    section,
  } = props;
  const getPatchTagsData = usePatchTagsData(
    {
      id_ipmp: accountId,
      version,
    },
    section,
  );

  const { mutationDeleteFile, mutationDeleteTag, refetch } = useMemo(() => {
    switch (section) {
      case VERSION:
        return {
          mutationDeleteFile: DELETE_IQ_PATCH_TAG_FILE,
          mutationDeleteTag: UPDATE_IQ_PATCH_TAG_FILE,
          refetch: READ_VERSION_FILES_QUERY_NAME,
        };
      case ACCOUNT:
        return {
          mutationDeleteFile: DELETE_ACCOUNT_IQ_PATCH_TAG_FILE,
          mutationDeleteTag: UPDATE_ACCOUNT_IQ_PATCH_TAG_FILE,
          refetch: GET_ACCOUNT_FILES_NAME,
        };
    }
  }, [section]);

  const tagForm = pluralize(selected.length, "tag");

  const renderSubtitle = () => {
    if (selected.length > 1 || !name) {
      return `Selected patch ${tagForm} (${selected.length}) will be deleted permanently.`;
    }
    return `The patch tag "${name}" will be deleted permanently.`;
  };

  const additionalProps = useMemo(() => {
    let patchTagsData = getPatchTagsData();
    if (!selected.length) {
      return {
        mutationQueries: mutationDeleteFile,
        title: "Delete patch tags file",
        subTitle: "The file will be deleted permanently.",
        initialValues: { ids: patchTagsData?.idFile },
      };
    }
    const iq_patch_tags = [];
    patchTagsData?.patchTags?.forEach((item) => {
      if (selected.includes(item.id)) return;
      iq_patch_tags.push(item.patchTag);
    });
    return {
      mutationQueries: mutationDeleteTag,
      title: `Delete patch ${tagForm}`,
      subTitle: renderSubtitle(),
      initialValues: {
        id_ipmp: accountId,
        version,
        iq_patch_tags,
      },
    };
  }, [selected]);

  return (
    <ConfirmDialog
      refetchQueries={[refetch]}
      Icon={DeleteIcon}
      submitButtonName="Delete"
      onClose={onClose}
      variant="error"
      onSuccessCallback={onSuccessCallback}
      {...additionalProps}
    />
  );
};

DeletePatchTagsDialog.propTypes = {
  selected: PropTypes.array,
  name: PropTypes.string,
  onSuccessCallback: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.number,
  version: PropTypes.string,
  section: PropTypes.string,
};

export default DeletePatchTagsDialog;
